import { Menu, Select } from 'antd'
import { useSelector } from 'react-redux'
import { faHourglassEnd } from '@fortawesome/pro-solid-svg-icons'

import IconLabel, { FontSizes } from '../../../../Components/icons/IconLabel'
import { selectTranslate } from '../../../../reducers/LocaleReducer/LocalReducer'
import { ExpiryFilters } from '../../../../utils/entities/schoolPortalRequest'

const SELECTOR_STYLE = { width: '210px' }
const MENU_ITEM_STYLE = { cursor: 'default', height: 'auto', lineHeight: 1.5, overflow: 'visible', padding: '4px 16px' }

const EXPIRY_LABELS = Object.freeze({
  [ExpiryFilters.OPEN]: 'school_requests_table.filters.open',
  [ExpiryFilters.EXPIRED]: 'school_requests_table.filters.expired'
})

/** Only the filters owned by this menu : `search` shares the same bag and must survive a reset. */
export const DEFAULT_SCHOOL_REQUEST_FILTERS = Object.freeze({ expiry: null })

export const getActiveFiltersCount = filters => (filters ?? {}).expiry ? 1 : 0

const SchoolRequestFilters = ({ filters, onFiltersChange }) => {
  const t = useSelector(selectTranslate)

  return (
    <div style={{ padding: '8px 0' }}>
      <Menu inlineIndent={0} style={{ border: 'none' }}>
        <Menu.ItemGroup
          title={
            <IconLabel
              fontSize={FontSizes.SMALL}
              padding={0}
              icon={faHourglassEnd}
              text={t('school_requests_table.filters.expiry')}
            />
          }
        >
          <Menu.Item key='expiry' disabled style={MENU_ITEM_STYLE}>
            <Select
              allowClear
              style={SELECTOR_STYLE}
              value={filters?.expiry ?? undefined}
              placeholder={t('school_requests_table.filters.all')}
              onChange={value => onFiltersChange({ ...filters, expiry: value ?? null })}
            >
              {Object.entries(EXPIRY_LABELS).map(([value, label]) => (
                <Select.Option key={value} value={value}>{t(label)}</Select.Option>
              ))}
            </Select>
          </Menu.Item>
        </Menu.ItemGroup>
      </Menu>
    </div>
  )
}

export default SchoolRequestFilters
